import { Checkbox, Input, InputNumber, message, Modal } from 'antd';
import axiosInstance from '../../../../../axios/axiosInstance';
import React, { useEffect, useState } from 'react';
import { ModePage } from 'common/enum';
import { SubjectRequest } from 'model/request';
import processError from '../../../../../utils/processError';

interface Props {
  isOpen: boolean;
  onCloseModal: () => void;
  mode: ModePage;
  onBeforeSuccess: () => void;
  subjectId: string;
}

export default function SubjectFormModal({ isOpen, onCloseModal, mode, onBeforeSuccess, subjectId }: Props) {
  const [newSubject, setNewSubject] = useState<SubjectRequest | null>(null);

  const onInputField = (e: any, fieldName: string) => {
    const newSubjectTemp = { ...newSubject } as any;
    newSubjectTemp[fieldName] = e.target.value;

    setNewSubject(newSubjectTemp);
  };

  const onCheckboxField = (e: any, fieldName: string) => {
    const newSubjectTemp = { ...newSubject } as any;
    newSubjectTemp[fieldName] = e.target.checked;

    setNewSubject(newSubjectTemp);
  };

  const loadNewSubject = async () => {
    try {
      const newSubject: SubjectRequest = {
        id: '',
        name: '',
        code: '',
        webViewActive: true,
        webViewOrder: 1,
      };
      setNewSubject(newSubject);
    } catch (err) {
      processError(err);
    }
  };

  const loadEditSubject = async () => {
    try {
      const res = await axiosInstance({
        url: `/subjects/${subjectId}`,
        method: 'get',
      });

      if (res.status === 200) {
        setNewSubject(res.data);
      } else {
        message.error('Có lỗi xảy ra.');
      }
    } catch (err) {
      processError(err);
    }
  };

  const onOk = async () => {
    if (!newSubject?.name) {
      message.error('Vui lòng nhập tên môn học');
      return;
    }
    try {
      if (newSubject) {
        await axiosInstance({
          url: mode === ModePage.ADD ? '/subjects' : `/subjects/${newSubject.id}`,
          method: mode === ModePage.ADD ? 'post' : 'put',
          data: newSubject,
        });
        onBeforeSuccess();
        message.success(mode === ModePage.ADD ? `Thêm thành công` : `Sửa thành công`);
      }
    } catch (err) {
      processError(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      mode === ModePage.ADD ? loadNewSubject() : loadEditSubject();
    }
  }, [isOpen]);

  return (
    <Modal open={isOpen} onOk={onOk} onCancel={onCloseModal}>
      <div className="mt-8">
        <div className="flex items-center gap-2">
          <div className="w-[210px]">
            Tên môn học: <span className={'text-FF1D30'}>*</span>
          </div>
          <Input maxLength={255} name="name" onChange={(e) => onInputField(e, 'name')} value={newSubject?.name} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <div className="w-[210px]">Mã môn học:</div>
          <Input maxLength={255} name="code" onChange={(e) => onInputField(e, 'code')} value={newSubject?.code} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>Hiển thị trên web</label> <br />
          <Checkbox checked={newSubject?.webViewActive} onChange={(e) => onCheckboxField(e, 'webViewActive')} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>
            Độ ưu tiên hiển thị <span className={'text-FF1D30'}>*</span>
          </label>{' '}
          <br />
          <InputNumber
            placeholder="Nhập độ ưu tiên hiển thị..."
            value={newSubject?.webViewOrder}
            onChange={(e) =>
              newSubject &&
              setNewSubject({
                ...newSubject,
                webViewOrder: e || 1,
              })
            }
            required
          />
        </div>
      </div>
    </Modal>
  );
}
